/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { IC_DELIVERY_TRUCK } from '../../Assets/images';

export const CommonServiceCarouselStyled = styled.div`
  .ePharmacy {
    .link {
      color: ${(props) => props.theme.blue.royal};

      &:hover {
        color: ${(props) => props.theme.blue.light};
      }
    }
  }

  .slick-slider {
    margin: 0 0 20px 0;

    .slick-list {
      width: 100%;
      margin: 0;
    }
  }

  .dealItemBox {
    width: 100%;

    .item {
      width: 100%;
      min-height: 390px;
      margin: 0 7px 0 0px;
      background: ${(props) => props.theme.color.white};
      border: 1px solid ${(props) => props.theme.color.lightGray};
      border-radius: 8px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      a {
        width: 100%;
        height: 0px;
      }

      .offTag {
        font-size: 13px;
        font-weight: 700;
        color: ${(props) => props.theme.color.white};
        background: ${(props) => props.theme.verification.red.main};
        padding: 5px 10px;
        border-radius: 8px 0;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }

      .img {
        width: 120px;
        height: 120px;
        margin: 0px auto;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
      .exclusive {
        color: ${(props) => props.theme.color.white};
        background: ${(props) => props.theme.blue.dark}B3;
        font-size: 10px;
        font-weight: 700;
        padding: 5px 5px 5px 10px;
        text-transform: uppercase;
        position: relative;
        white-space: nowrap;
        margin: 0 0 8px 0;

        &:before {
          border-top: 13px solid ${(props) => props.theme.blue.dark}4D;
          border-right: 10px solid transparent;
          border-left: 10px solid transparent;
          content: '';
          position: absolute;
          top: 0;
          left: 100%;
        }

        &:after {
          border-top: 25px solid transparent;
          border-right: 25px solid transparent;
          border-left: 20px solid ${(props) => props.theme.blue.dark}B3;
          content: '';
          position: absolute;
          bottom: 0;
          left: 100%;
        }
      }
      .name {
        width: 100%;
        margin: 0 0 8px 0;
        font-size: 15px;
        font-weight: 600;
        overflow: hidden;
        cursor: pointer;
      }
      .price {
        width: 100%;
        margin: 0 0 8px 0;
        display: flex;
        align-items: center;

        .new {
          font-size: 16px;
          font-weight: 700;
          margin: 0 5px 0 0;
        }
        .actual {
          color: ${(props) => props.theme.text.medium};
          font-size: 12px;
          font-weight: 600;
          text-decoration: line-through;
        }
      }
      .delivery {
        height: 39px;
        background: url(${IC_DELIVERY_TRUCK.src}) no-repeat 0 6px / 16px;
        color: ${(props) => props.theme.text.medium};
        font-size: 10px;
        text-align: left;
        padding: 3px 0 0 20px;
        margin: 0 0 8px 0;
        overflow: hidden;
        span {
          font-weight: 700;
        }
      }
    }
  }

  @media (max-width: 820px) {
    padding: 0 0 5px 0;

    .container {
      padding: 16px 0;
    }

    .slick-slider {
      margin: 0;
    }
  }

  @media (max-width: 480px) {
    .slick-slide {
      width: 45.5vw !important;
    }
    .sectionBox {
      padding-bottom: 0;
      padding-left: 0;
      padding-right: 0;

      .container {
        .titleBar {
          padding-left: 16px;
          padding-right: 16px;
        }

        .slick-arrow {
          &.slick-prev {
            left: 0;
          }
          &.slick-next {
            right: 0;
          }
        }
      }
    }
    .container {
      .pageContent {
        .titleBar {
          .title {
            font-size: 18px;
            margin: 16px;
          }
        }
      }
    }

    .dealItemBox {
      max-width: 100%;
      margin: 0;

      .item {
        padding: 10px;
        border-radius: 0;
        border-left: 0;
        border-top: 0;
        min-height: 325px;
        width: 220px;

        .badgeStack {
          .wrapper {
            font-size: 11px;
          }
        }
        .addToWishList {
          top: 10px;
          right: 10px;
        }
        .imgWrapper {
          padding-bottom: 0;
          .img {
            width: 100px;
            height: 100px;
          }
        }
        .name {
          height: 36px;
          font-size: 14px;
          line-height: 17px;
          margin-bottom: 2px;
        }
        .price {
          font-size: 13px;
          margin-bottom: 2px;

          .new {
            font-size: 14px;
          }
        }
        .delivery {
          height: 30px;
          background-position: 0 5px;
          font-size: 10px;
          line-height: 14px;
          margin-bottom: 4px;
        }
        .add-to-card {
          .btn {
            font-size: 12px;
            padding: 5px 10px;
          }
        }
      }
    }
    .container {
      .pageContent {
        .titleBar {
          .title {
            font-size: 18px;
            margin: 16px;
          }
        }
      }
    }

    .dealItemBox {
      max-width: 100%;
      margin: 0;

      .item {
        padding: 10px;

        .badgeStack {
          .wrapper {
            font-size: 11px;
          }
        }
        .addToWishList {
          top: 10px;
          right: 10px;
        }
        .imgWrapper {
          padding-bottom: 0;
          .img {
            width: 100px;
            height: 100px;
          }
        }
        .name {
          height: 36px;
          font-size: 14px;
          line-height: 17px;
          margin-bottom: 2px;
        }
        .price {
          font-size: 13px;
          margin-bottom: 2px;

          .new {
            font-size: 14px;
          }
        }
        .delivery {
          height: 30px;
          background-position: 0 6px;
          font-size: 10px;
          line-height: 14px;
          margin-bottom: 4px;
        }
        .add-to-card {
          .btn {
            font-size: 12px;
            padding: 5px 10px;
          }
        }
      }
    }
  }
  @media (max-width: 380px) {
    .slick-slide {
      width: 65vw !important;
    }
  }
`;
